import React from 'react';
import { TARGETING_TACTICS_VIEW } from 'constants/capabilities';
import ProtectedComponent from 'hoc/ProtectedComponent';
import PlacementsTable from 'components/molecules/tables/PlacementsTable';

const ProtectedTargetingTacticsTable = ProtectedComponent({
    requiredCapabilities: [TARGETING_TACTICS_VIEW]
})(props => (
    <React.Fragment>
        {props.showTargetingTactics ? (
            <PlacementsTable {...props} />
        ) : null}
    </React.Fragment>
)
);

ProtectedTargetingTacticsTable.propTypes = PlacementsTable.propTypes;

export default ProtectedTargetingTacticsTable;



// WEBPACK FOOTER //
// ./src/components/organisms/ProtectedTargetingTacticsTable.js